import { useContext } from 'react';

import { Answer, Question } from '~/types';

import StyledButton from '~/components/StyledButton';

import axios from 'axios';

import Fade from '~/components/Fade';
import { useTranslation } from 'react-i18next';
import { detectMobileOS } from '~/util/util';
import MatomoTracker from '~/util/matomo/MatomoTracker';

import { AppContext } from '~/contexts/AppContext';
import { QuestionContext } from '~/contexts/QuestionContext';

import * as topicUtils from '~/util/topic';
import { useParams } from 'react-router-dom';

const SingleChoiceAnswer: React.FC = () => {

    const { topicData, apiUrl, preciseCoordinates } = useContext(AppContext)!;
    const { question, onSubmitAnswer, questionTime, ratingId } = useContext(QuestionContext)!;

    const { i18n } = useTranslation();

    const params: { topicHash: string } = useParams();

    const buttonClicked = async (answer: Answer) => {
        if (answer.link) {
            let answerLink = answer.link;
            const mobileOs = detectMobileOS();
        
            const matches = answerLink.match(/{(.*?)}/g) ?? [];
            
            for(const match of matches) {
                const strippedStr = match.slice(1, match.length - 1);
                
                let strToReplaceWith = '';
        
                if(mobileOs === 'ios' && strippedStr.startsWith('ios:')) {
                    strToReplaceWith = strippedStr.replace('ios:', '');
                } else if(mobileOs === 'android' && strippedStr.startsWith('android:')) {
                    strToReplaceWith = strippedStr.replace('android:', '');
                } else if(mobileOs === 'unknown' && strippedStr.startsWith('default:')) {
                    strToReplaceWith = strippedStr.replace('default:', '');
                }
        
                answerLink = answerLink.replace(match, strToReplaceWith);
            }

            MatomoTracker.trackLink({ href: answerLink});

            window.open(answerLink, '_blank');
        }

        await axios.post(`${apiUrl}/rating-answer/${topicData?.topic.id}/single-choice`, {
            ratingId: ratingId,
            questionnaireId: question.questionnaireId,
            questionId: question.questionId,
            preciseCoordinates: preciseCoordinates,
            timeToAnswerMs: !questionTime ? 0 : Date.now() - questionTime,
            lang: i18n.language,
            answerId: answer.answerId
        });

        if(!answer.link) {

            const questionText = topicUtils.getQuestionText(topicData, question.questionId, i18n.language);
            const answerText = topicUtils.getAnswerText(topicData, question.questionId, answer.answerId, i18n.language);

            MatomoTracker.trackEvent({
                category: 'qna', 
                action: 'submit-answer',
                documentTitle: topicData?.topic.name,
                href: `https://kazva.bg/${params.topicHash}`,
                customDimensions: [
                    { id: 3, value: questionText },
                    { id: 4, value: answerText },
                    { id: 5, value: '' }
                ]
            });
        }

        if (answer.nextQuestionId)
            onSubmitAnswer(answer.nextQuestionId);
        else
            onSubmitAnswer(null);
    };

    return (
        <Fade cascade>
            {question.answers.map((answer: Answer, i: number) =>
                <StyledButton key={i} onClick={() => buttonClicked(answer)}>
                    {answer.link ? '🌐' : null} {topicUtils.getAnswerText(
                        topicData,
                        question.questionId,
                        answer.answerId,
                        i18n.language
                    )}
                </StyledButton>
            )}
        </Fade>
    );
};

export default SingleChoiceAnswer;